import { REASON_OFFLINE, REASON_OUT_OF_AREA } from "../detail/deliverability";

const noun = (count) => (count === 1 ? "accessory" : "accessories");

export const unavailableSummary = (cards) => {
  const blocked = (cards || []).filter((card) => card?.notice);

  if (!blocked.length) return null;

  const count = blocked.length;

  const outOfArea = blocked.filter(
    (card) => card.notice.reason === REASON_OUT_OF_AREA
  ).length;

  const offline = blocked.filter(
    (card) => card.notice.reason === REASON_OFFLINE
  ).length;

  if (offline === count) {
    return `${count} ${noun(count)} below ${
      count === 1 ? "is" : "are"
    } from suppliers who are offline and cannot take orders right now.`;
  }

  if (outOfArea === count) {
    return `${count} ${noun(count)} below ${
      count === 1 ? "is" : "are"
    } outside ${
      count === 1 ? "its supplier's" : "their suppliers'"
    } delivery ${count === 1 ? "area" : "areas"} and cannot be ordered to this address.`;
  }

  return `${count} ${noun(count)} below cannot be ordered to this address — ${outOfArea} ${
    outOfArea === 1 ? "is" : "are"
  } outside the delivery area and ${offline} ${
    offline === 1 ? "is" : "are"
  } from an offline supplier.`;
};

export const emptyState = ({ term, categoryLabel, activeFilters, isError }) => {
  if (isError) {
    return {
      kind: "error",
      title: "Something went wrong",
      body: "We could not load accessories just now.",
      retry: true,
    };
  }

  const trimmed = String(term || "").trim();

  if (trimmed) {
    return {
      kind: "search",
      title: `No results for “${trimmed}”`,
      body: "Try a different spelling, or clear your filters.",
    };
  }

  if (categoryLabel) {
    return {
      kind: "category",
      title: `No accessories in ${categoryLabel}`,
      body: `Nothing is listed under ${categoryLabel} yet. Tap “All” to see every accessory.`,
    };
  }

  if (activeFilters > 0) {
    return {
      kind: "filters",
      title: "No matching accessories",
      body: "No accessory matches these filters. Try widening them.",
    };
  }

  return {
    kind: "empty",
    title: "No accessories yet",
    body: "There is nothing listed here at the moment. Please check back soon.",
  };
};

export const resultsLabel = (total) =>
  `${total} ${total === 1 ? "accessory" : "accessories"}`;

export const BANNER = {
  eyebrow: "Discover and Fit",
  title: "Accessories Worth Owning",
  blurb:
    "Regulators, hoses, burners and every part that keeps your cylinders running. Browse what nearby suppliers stock and have it delivered with your next order.",
};
